<template>
  <div class="container">
    <van-image class="page-title" :src="require('@/assets/educational/ketang@2x.png')"/>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onReachBottom"
    >
      <div class="list">
        <template v-for="(item, index) of list">
          <div class="item" :key="index" @click="Detile(item)">
            <div style="visibility:hidden" class="subscript">手绘地图</div>
            <van-image
              class="img"
              :src="item.coverImage"
            />
            <div class="title">{{ item.title }}</div>
          </div>
        </template>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getPbEducationOnlineClass } from '@/api/educational'

export default {
  name: 'OnlineClassroom',
  data: () => ({
    list: [],
    loading: false,
    finished: false,
    pageNo: 1
  }),
  mounted () {
    this.getClassroom()
  },
  methods: {
    async getClassroom () {
      this.loading = true
      if (!this.finished) {
        const { result } = await getPbEducationOnlineClass({
          pageNo: this.pageNo++
        })
        console.log(result)
        this.loading = false
        this.finished = result.current === result.pages
        this.list = [...this.list, ...result.records]
      }
    },
    Detile (item) {
      window.location.href = item.video
    },
    onReachBottom () {
      this.getClassroom()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f3e6dd;
  overflow: hidden;

  .page-title {
    width: 252px;
    display: block;
    margin: 20px auto;
  }

  .list {
    margin: 0 20px;

    .item {
      border-radius: 4px;
      background-color: #b09476;
      margin-bottom: 20px;
      overflow: hidden;

      .subscript {
        display: inline-block;
        background-color: #773e36;
        border-radius: 4px 0px 4px 0px;
        padding: 2px 4px;
        font-size: 14px;
        color: #a98f72;
      }

      .img {
        margin: 0 18px;
        border-radius: 4px;
        overflow: hidden;
      }

      .title {
        margin-top: 14px;
        padding: 12px 18px 16px;
        font-size: 16px;
        color: #312925;
        font-weight: 500;
        line-height: 1.5;
        background: linear-gradient(0deg, #B09476 0%, #8F7152 100%);
      }
    }
  }
}
</style>
